const doc = [({"ja":({"adminConstantListTypes":({"roomList":"部屋一覧で表示", "planList":"プラン一覧で表示"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;